module.exports = __webpack_public_path__ + "img/banner-left.773a8634.svg";